import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DSRESTClient } from '../shared/communication-objects/restclient.service';

@Injectable()
export class TankViewProfileService {

  private apiURL: string = "TankViewProfile";

  constructor(
    private restClient: DSRESTClient,
    private httpClient: HttpClient) { }


  getTvpSimpleList(): Observable<any> {
    let allTvps = this.restClient.get<any>(`${this.apiURL}/GetListOfUserTvps`);
    return allTvps;
  }

  getAllTvps(): Observable<any> {
    let allTvps = this.restClient.get<any>(`${this.apiURL}/GetUsersTvps`);
    return allTvps;
    }

  getLastSelectedTvp(): Observable<any> {
    let tvp = this.restClient.get<any>(`${this.apiURL}/GetLastSelectedTvp`);
    return tvp;
  }
}
